export default function Pencil({
    onClick,
    active,
}: {
    active: boolean;
    onClick: () => void;
}) {
    return (
        <button title="Paint (B)"  type="button" className="brush-tool" onClick={() => onClick()}>
            <svg
                width={32} height={32}
                fill={active ? "#c4c4c4" : "#5f5f5f"}
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="m167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35.01 82.35 37.94 154.73 128.01 154.73 75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13zm290.87-309.34c-15.16 0-29.37 6.71-40.21 16.45-204.41 182.6-225.68 186.89-225.68 240.64 0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99 0-28.91-26-49.55-54.11-49.55z" />
            </svg>
        </button>
    );
}
